import { memo, useMemo } from "react";
import { ColumnRowProps } from "../../ColumnRowProps";
import { ColumnGridContainer } from "../ColumnGridContainer";
import { ContractCell } from "../contract/ContractCell";


export const TopRowColumnRow = memo(function TopRowColumnRow({ columnRow }: ColumnRowProps) {
    const render = useMemo(() => {
        return columnRow?.cells.map((cell, i) => {
            if (!cell) {
                return <div key={i} />;
            }
            return <ContractCell key={cell.id} cell={cell} cells={columnRow.cells} containsCategory={columnRow.metadata?.ContainsCategoryWork} />;
        });
    }, [columnRow?.cells, columnRow?.metadata?.ContainsCategoryWork]);
    return <ColumnGridContainer>{render}</ColumnGridContainer>;
});
